<template>
  <b-container>
    <div class="wrapper__edit-forum d-flex flex-column justify-content-center">
      <edit-forum-header
        v-if="forum && learningUnitOwner"
        :learning-unit-id="learningUnitId"
        :forum="forum"
        :forum-owner="learningUnitOwner"
      />
    </div>
  </b-container>
</template>

<script>
import EditForumHeader from './components/EditForumHeader.vue';
import LearningUnit from '@/models/LearningUnit';
import Forum from '@/models/Forum';
import UserRole from '@/models/UserRole';

export default {
  components: {
    EditForumHeader
  },
  data() {
    return {};
  },
  computed: {
    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.query().with('learning_unit_members').find(this.learningUnitId);
    },

    forumId() {
      return Number.parseInt(this.$route.params.forumId);
    },

    forum() {
      return Forum.query().where('id', this.forumId).first();
    },

    learningUnitOwner() {
      const ownerRole = UserRole.learningUnitOwner();

      if (this.learningUnit && this.learningUnit.learning_unit_members.length) {
        return this.learningUnit.learning_unit_members.find(
          (member) => member.user_role === ownerRole.id
        );
      }

      return null;
    }
  },
  async mounted() {
    await this.fetch();
  },
  methods: {
    async fetch() {
      await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      await Forum.api().fetchById(this.forumId);
    }
  }
};
</script>

<style scoped></style>
